import { createSelector } from "@reduxjs/toolkit";

export const singleAgentState = (state) => state.singleAgent;

export const singleAgentSelector = createSelector(singleAgentState, (state) => state);
